import React, { Fragment, useContext } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { Breadcrumbs, Btn, H4, H5 } from '../../../../../../AbstractElements';
import CheckoutTableData from './CheckoutTableData';
import ProductPlaceOrder from './ProductPlaceOrder';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomizerContext from '../../../../../../_helper/Customizer';

const CheckOutPrescription = () => {
  const { layoutURL } = useContext(CustomizerContext);
  const navigate = useNavigate();

  const location = useLocation()

  const {rowData, data} = location.state || {}
    const handleBack = () => {
      
      navigate(`${process.env.PUBLIC_URL}/prescriptioninvoice/:layout`, { state: { data , rowData} })
        // navigate(`/patientinfo/prescription`, { state: { data , rowData} })
    }
  return (
    <Fragment>
      <Breadcrumbs parent='Ecommerce' title='Checkout' mainTitle='Checkout' />
      <Container fluid={true}>
        <Row>
          <Col>
            <Card className='checkout'>
              <div className="d-flex justify-content-between align-items-center">
              {/* <HeaderCard title={"Billing Details"} /> */}
              <CardHeader><H4> {"Billing Details"} </H4></CardHeader>
              <CardHeader><Btn attrBtn={{ color: 'danger' , onClick: handleBack}}>{"View Invoice"}</Btn></CardHeader>
              </div>
              <CardBody>
                <Row>
                  <CheckoutTableData />
                  <ProductPlaceOrder />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default CheckOutPrescription;
